import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgFlashOutline = function SvgFlashOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2206 1.64603C12.917 0.636058 14.4996 1.12913 14.4996 2.35563V7.99993H20.2974C21.3046 7.99993 21.8985 9.13024 21.3265 9.9596C21.3264 9.95962 21.3265 9.95958 21.3265 9.9596L12.7787 22.3539C12.0822 23.3636 10.4996 22.871 10.4996 21.6442V15.9999H4.70185C3.69447 15.9999 3.10101 14.8694 3.67283 14.0402L12.2206 1.64603ZM12.9996 3.15849L5.17793 14.4999H10.7496C11.44 14.4999 11.9996 15.0596 11.9996 15.7499V20.8414L19.8213 9.49994H14.2496C13.5594 9.49994 12.9996 8.94033 12.9996 8.24993V3.15849ZM13.4552 2.49787C13.4552 2.49799 13.4553 2.49775 13.4552 2.49787V2.49787Z"
  })));
};

export { SvgFlashOutline as ReactComponent };
//# sourceMappingURL=flash-outline.svg.js.map
